const $inject = [];

const lbLoadingPlaceholderItemCtrl = function () {
  let vm = this;

  vm.minWidth = vm.minWidth || 20;
  vm.maxWidth = vm.maxWidth || 80;
  vm.items = createItems(vm.total);

  vm.getItemWidth = getItemWidth;

  function createItems(totalItems = 1) {
    return _.map(_.times(totalItems), (item) => {
      return {
        width: getItemWidth(item)
      };
    });
  }

  function getItemWidth() {
    return vm.width || randomWidth();
  }

  function randomWidth() {
    return _.random(vm.minWidth, vm.maxWidth) + '%';
  }
};

lbLoadingPlaceholderItemCtrl.$inject = $inject;

export default lbLoadingPlaceholderItemCtrl;



// WEBPACK FOOTER //
// ./src/components/lbLoadingPlaceholder/lbLoadingPlaceholderItemCtrl.js